export default __webpack_public_path__ + "static/media/36I-114281_-20919_0.8173ccb2.jpg";